import { useState } from 'react';
import { PiImage } from 'react-icons/pi';
import { ITitle } from 'services/types';
import './ReleaseCard.scss';

interface IReleaseCardProps {
  cover: string;
  title: ITitle;
  onClick: () => void;
}

const ReleaseCard = ({ cover, title, onClick }: IReleaseCardProps) => {
  const [coverError, setCoverError] = useState(false);
  return (
    <div className="release-card" onClick={onClick}>
      <div className="release-card-cover">
        {!coverError ? <img src={cover} onError={() => setCoverError(true)} /> : <PiImage />}
      </div>

      <div className="release-card-title">{title.title}</div>
      {title.version && <div className="release-card-version">{title.version}</div>}
    </div>
  );
};

export default ReleaseCard;
